//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';
import { connect } from 'react-redux';
import Redux, { bindActionCreators } from 'redux';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'unison';

import { ICuralateStore } from '@models/AppState';
import {
  closeAssetFeedsDrawer,
  closeStreamModal,
} from '@streams-drawer/actions/streams-drawer-actions';
import { StreamModalType } from '@streams-drawer/streams-drawer-constants';

function mapStateToProps(state: ICuralateStore) {
  return {
    openModal: state.streams.streamsDrawer.openStreamModal,
  };
}

function mapDispatchToProps(dispatch: Redux.Dispatch) {
  return {
    actions: {
      closeStreamModal: bindActionCreators(closeStreamModal, dispatch),
      closeAssetFeedsDrawer: bindActionCreators(
        closeAssetFeedsDrawer,
        dispatch,
      ),
    },
  };
}

interface Props
  extends ReturnType<typeof mapStateToProps>,
    ReturnType<typeof mapDispatchToProps> {}

export const StreamsDrawerAssetFeedsCloseConfirmationModal = (props: Props) => {
  const { actions, openModal } = props;

  return (
    <Modal
      isOpen={openModal === StreamModalType.ASSET_FEEDS_CLOSE_CONFIRMATION}
    >
      <ModalHeader onCancel={actions.closeStreamModal}>
        Are you sure?
      </ModalHeader>
      <ModalBody className='cu-d-block cu-wide-measure'>
        <div className='cu-mb-5'>
          Are you sure you want to close? You will lose any unsaved changes.
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          className='cu-button-secondary'
          onClick={actions.closeStreamModal}
        >
          Cancel
        </Button>
        <Button
          className='cu-button-primary cu-ml-2'
          onClick={actions.closeAssetFeedsDrawer}
        >
          Yes, Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StreamsDrawerAssetFeedsCloseConfirmationModal);
